export function h(
  node: string,
  props: Record<string, string> = {},
  options?: ({ children?: (HTMLElement | SVGElement)[] } | { text?: string } | { html?: string }) & {
    baseClass?: boolean
    parent?: HTMLElement | SVGElement
    svg?: boolean
  },
): HTMLElement | SVGElement {
  const el = options?.svg ? document.createElementNS('http://www.w3.org/2000/svg', node) : document.createElement(node)

  if (options?.svg) {
    el.setAttribute('xmlns', 'http://www.w3.org/2000/svg')
  }

  Object.entries(props).forEach(([key, value]) => el.setAttribute(key, value))

  if (options?.baseClass !== false) {
    el.classList.add('vbzc')
  }

  if (options) {
    if ('children' in options) {
      options.children?.forEach((child) => el.append(child))
    } else if ('text' in options) {
      el.textContent = options.text || ''
    } else if ('html' in options) {
      el.innerHTML = options.html || ''
    }

    if (options.parent) {
      options.parent.append(el)
    }
  }

  return el
}

export function caretIcon(direction: 'up' | 'right' | 'down' | 'left') {
  return h(
    'svg',
    {
      class:
        direction === 'left'
          ? 'vbzc-rotate-90'
          : direction === 'up'
            ? 'vbzc-rotate-180'
            : direction === 'right'
              ? 'vbzc-rotate-270'
              : '',
      width: '1em',
      height: '1em',
      fill: 'currentColor',
      viewBox: '0 0 256 256',
    },
    {
      svg: true,
      baseClass: false,
      children: [
        h(
          'path',
          {
            d: 'M216.49,104.49l-80,80a12,12,0,0,1-17,0l-80-80a12,12,0,0,1,17-17L128,159l71.51-71.52a12,12,0,0,1,17,17Z',
          },
          { svg: true, baseClass: false },
        ),
      ],
    },
  )
}

export function closeIcon() {
  return h(
    'svg',
    {
      width: '1em',
      height: '1em',
      fill: 'currentColor',
      viewBox: '0 0 256 256',
    },
    {
      svg: true,
      baseClass: false,
      children: [
        h(
          'path',
          {
            d: 'M208.49,191.51a12,12,0,0,1-17,17L128,145,64.49,208.49a12,12,0,0,1-17-17L111,128,47.51,64.49a12,12,0,0,1,17-17L128,111l63.51-63.52a12,12,0,0,1,17,17L145,128Z',
          },
          { svg: true, baseClass: false },
        ),
      ],
    },
  )
}

export function checkIcon() {
  return h(
    'svg',
    {
      width: '1em',
      height: '1em',
      fill: 'currentColor',
      viewBox: '0 0 256 256',
    },
    {
      svg: true,
      baseClass: false,
      children: [
        h(
          'path',
          {
            d: 'M232.49,80.49l-128,128a12,12,0,0,1-17,0l-56-56a12,12,0,1,1,17-17L96,183,215.51,63.51a12,12,0,0,1,17,17Z',
          },
          { svg: true, baseClass: false },
        ),
      ],
    },
  )
}

export function wrapInParagraph(text: string) {
  const trimmed = text.trim()
  const html = trimmed.startsWith('<') ? trimmed : `<p>${trimmed}</p>`
  return html.replace(/\[(https?:\/\/.+)\]/g, '<img src="$1">')
}
